import React from "react";
import { PORTFOLIO } from "../data/siteData";
import ContactForm from "./ContactForm";

export default function PortfolioPage() {
  const d = PORTFOLIO;

  return (
    <>
      {/* Hero — text only */}
      <section className="portfolio-text-hero">
        <h1>{d.hero.title}</h1>
      </section>

      {/* Banner image */}
      <section className="portfolio-banner">
        <img src="/assets/project-banner.png" alt={d.hero.title} />
      </section>

      {/* Summary — left aligned */}
      <section className="section">
        <h2 style={{ textAlign: "left" }}>Project Summary</h2>
        <p className="portfolio-summary-left">{d.hero.summary}</p>
      </section>

      {/* Projects — same style as landing recent projects - Only first row */}
      <section className="landing-projects">
        <div className="landing-projects-overlay" />
        <div className="landing-projects-header">
          <h2 className="landing-projects-title">Our Projects</h2>
        </div>
        <div className="landing-projects-grid">
          {d.projects.slice(0, 2).map((p, i) => (
            <div key={i} className="lp-card">
              <div className="lp-card-img">
                <img src="/assets/project-banner.png" alt={p.title} />
              </div>
              <div className="lp-card-info">
                <div className="lp-card-text">
                  <h4>{p.title}</h4>
                  <p>{p.desc}</p>
                </div>
                <div className="lp-card-arrow">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c9d1d9" strokeWidth="1.5">
                    <path d="M7 17L17 7M17 7H9M17 7V15" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <ContactForm />
    </>
  );
}
